import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin, Linkedin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#081221] text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-3 mb-6">
              <img 
                src="/logo.jpg" 
                alt="TerniEnergia Progetti" 
                className="h-12 w-auto object-contain"
              />
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              Soluzioni EPC full-scope, O&M e Asset Management per impianti fotovoltaici utility-scale.
            </p>
            <div className="flex space-x-4">
              <a href="https://it.linkedin.com/company/terniprogetti" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors">
                <Linkedin size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-serif text-lg font-bold mb-6">Link Rapidi</h3>
            <ul className="space-y-3">
              <li><Link to="/about" className="text-gray-400 hover:text-white transition-colors text-sm">Chi Siamo</Link></li>
              <li><Link to="/activities" className="text-gray-400 hover:text-white transition-colors text-sm">Attività</Link></li>
              <li><Link to="/track-record" className="text-gray-400 hover:text-white transition-colors text-sm">Track Record</Link></li>
              <li><Link to="/governance" className="text-gray-400 hover:text-white transition-colors text-sm">Governance</Link></li>
            </ul>
          </div>

          {/* Contatti */}
          <div>
            <h3 className="font-serif text-lg font-bold mb-6">Contatti</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <MapPin size={18} className="text-[#18a06b] mt-0.5 flex-shrink-0" />
                <span className="text-gray-400 text-sm">Via Giuseppe Garibaldi, 43<br />05100 Terni (TR), Italia</span>
              </li>
              <li className="flex items-center space-x-3">
                <Mail size={18} className="text-[#18a06b] flex-shrink-0" />
                <span className="text-gray-400 text-sm">info@ternienergia.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © 2025 TerniEnergia Progetti. Tutti i diritti riservati.
            </p>
            <div className="flex space-x-6">
              <Link to="#" className="text-gray-400 hover:text-white text-sm transition-colors">Privacy Policy</Link>
              <Link to="#" className="text-gray-400 hover:text-white text-sm transition-colors">Cookie Policy</Link>
              <Link to="#" className="text-gray-400 hover:text-white text-sm transition-colors">Note Legali</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
